import { isFlagEnabled } from "js/utilities";

import AgentChatStausCard from "./AgentChatStausCard";
import CustomerChatStatusCard from "./CustomerChatStatusCard";
import { useTranslation } from "react-i18next";

export default function SiteActions() {
  const { t } = useTranslation();
  return (
    <>
      <div className="container mb-8">
        <div className="ui-card mb-4 md:mb-6 p-4 xl:p-6">
          <div className="md:flex-grow ">
            <h2 className="mb-2 text-xl font-body font-bold">
              {t("AgentCSR-Admin-SiteActions-title")}
            </h2>
            <hr />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10">
            {isFlagEnabled("ENABLE_MANUAL_CHAT_TIME") && <AgentChatStausCard />}
            {isFlagEnabled("ENABLE_MANUAL_CHAT_TIME") && (
              <CustomerChatStatusCard />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
